import React, { memo } from 'react';
import { Text } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import style from './SharedZoneNewSubtitle.module.pcss';

const cx = classNames.bind(style);

const SharedZoneNewSubtitle = memo(({ subtitle }) => (
  <div className={cx('subtitle')}>
    <Text size="size4-r">{subtitle}</Text>
  </div>
));

export { SharedZoneNewSubtitle };
